import { rootRoute } from '../root';
run.$inject = ['$rootScope', '$location'];
export function run($rootScope, $location) {
    let first = true;
    $rootScope.$on('$locationChangeStart', ($event, newURL, oldURL) => {
        if (newURL == oldURL && !first) {
            return;
        }
        DEBUG: rootRoute.VERBOSE && console.group('voyager/angularjs/run check', { newURL, oldURL, rootRoute });
        if (!rootRoute.check($location.path())) {
            $event.preventDefault();
        }
        DEBUG: rootRoute.VERBOSE && console.groupEnd();
    });
    $rootScope.$on('$locationChangeSuccess', (_event, newURL, oldURL) => {
        if (newURL == oldURL && !first) {
            return;
        }
        first = false;
        DEBUG: rootRoute.VERBOSE && console.group('voyager/angularjs/run update', { rootRoute });
        rootRoute.update();
        DEBUG: rootRoute.VERBOSE && console.groupEnd();
    });
}
